if (import.meta.hot) {
	import.meta.hot.accept();
}

import { loadApp, loadModule } from '@spon/core';
import 'lazysizes';

import Header from '@/globals/Header';
import Modal from '@/globals/Modal';
import SetVh from '@/globals/SetVh';
import FadeIn from '@/globals/FadeIn';
import SmoothScroll from '@/globals/SmoothScroll';
import CopyText from '@/globals/CopyText';

import '@/plugins/logger';
import webfontloader from '@/plugins/webfontloader';
import detectTab from '@/utils/detectTab';
import activeLinks from '@/utils/activeLinks';
import localLinks from '@/utils/localLinks';
import { showMessage, hideMessage } from './ui/messages';

webfontloader();

// SmoothScroll registers before behaviours hydrate — they read its Lenis
// singleton (getLenis/scrollTo), so this ordering is a boot invariant.
loadModule({
	module: SmoothScroll,
	id: 'smooth-scroll',
	node: document.body,
	keepAlive: true,
});

// load from data-behaviours
const app = loadApp(name => import(`./behaviours/${name}.js`), document.body); // eslint-disable-line

loadModule({
	module: Header,
	id: 'header',
	node: document.getElementById('header'),
	keepAlive: true,
});

loadModule({
	module: Modal,
	id: 'modal',
	node: document.body,
	keepAlive: true,
});

loadModule({
	module: SetVh,
	id: 'set-vh',
	node: document.body,
	keepAlive: true,
});

loadModule({
	module: FadeIn,
	id: 'fadein',
	node: document.body,
	keepAlive: true,
});

loadModule({
	module: CopyText,
	id: 'copy-text',
	node: document.body,
	keepAlive: true,
});

detectTab();
activeLinks(window.location.pathname);
localLinks();

// https://htmx.org/events
if (typeof htmx !== 'undefined') {
	// Fade during HTMX loading

	htmx.on('htmx:beforeSend', () => {
		const results = document.getElementById('results');
		if (results) {
			results.classList.add('is-loading');
		}
	});

	// Scroll to top of `sprig` container when interacting; but only when `scroll` is in Param (eg not filtering; but probably pagination)

	htmx.on(
		'htmx:beforeSwap',
		({
			detail: {
				requestConfig: { triggeringEvent },
			},
			target,
		}) => {
			localLinks(target);

			if (triggeringEvent) {
				const { srcElement } = triggeringEvent;
				if (!srcElement) return;

				const shouldScroll = srcElement.closest('.c-pagination');
				if (srcElement && shouldScroll) {
					window.scrollTo({
						top: target.getBoundingClientRect().top + window.scrollY - 100,
						behavior: 'smooth',
					});
				}
			}
		}
	);

	// Used if sprig target != results; dont' rely on DOM change to remove `.is-loading`
	htmx.on('htmx:afterSwap', ({ target }) => {
		const results = document.getElementById('results');
		if (results) {
			results.classList.remove('is-loading');
		}

		loadApp(name => import(`./behaviours/${name}.js`), target);
	});

	htmx.on('htmx:responseError', ({ target }) => {
		showMessage('Something went wrong, please try again.');
	});
}
